import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';
import { FaArrowLeft, FaComments, FaPhone, FaEnvelope, FaQuestionCircle } from 'react-icons/fa';

const Container = styled.div`
  padding: 1rem;
`;

const BackButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: none;
  border: none;
  color: var(--text-primary);
  font-size: 16px;
  cursor: pointer;
  padding: 0.5rem 0;
  margin-bottom: 1rem;

  svg {
    font-size: 20px;
  }
`;

const Title = styled.h1`
  font-size: 24px;
  color: var(--text-primary);
  margin: 0 0 1.5rem 0;
`;

const SupportOptions = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1rem;
`;

const SupportCard = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  padding: 2rem;
  background-color: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: 10px;
  color: var(--text-primary);
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background-color: var(--primary-color-light);
    border-color: var(--primary-color);
    transform: translateY(-2px);
  }

  svg {
    font-size: 32px;
    color: var(--primary-color);
  }
`;

const CardTitle = styled.h2`
  font-size: 18px;
  margin: 0;
  text-align: center;
`;

const CardDescription = styled.p`
  font-size: 14px;
  color: var(--text-secondary);
  margin: 0;
  text-align: center;
`;

const Help: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();

  const supportOptions = [
    {
      id: 'chat',
      title: t('help.chat.title'),
      description: t('help.chat.description'),
      icon: FaComments,
      path: '/profile/help/chat'
    },
    {
      id: 'phone',
      title: t('help.phone.title'),
      description: t('help.phone.description'),
      icon: FaPhone,
      path: '/profile/help/phone'
    },
    {
      id: 'email',
      title: t('help.email.title'),
      description: t('help.email.description'),
      icon: FaEnvelope,
      path: '/profile/help/email'
    },
    {
      id: 'faq',
      title: t('help.faq.title'),
      description: t('help.faq.description'),
      icon: FaQuestionCircle,
      path: '/profile/help/faq'
    }
  ];

  return (
    <Container>
      <BackButton onClick={() => navigate('/profile')}>
        <FaArrowLeft />
        {t('common.back')}
      </BackButton>

      <Title>{t('help.title')}</Title>

      <SupportOptions>
        {supportOptions.map(option => {
          const Icon = option.icon;
          return (
            <SupportCard key={option.id} onClick={() => navigate(option.path)}>
              <Icon />
              <CardTitle>{option.title}</CardTitle>
              <CardDescription>{option.description}</CardDescription>
            </SupportCard>
          );
        })}
      </SupportOptions>
    </Container>
  );
};

export default Help; 